import {Box} from '@mantine/core';
import type {FC} from 'react';

type Props = {
  sectionTitle: string;
};

export const PcSectionTitle: FC<Props> = ({sectionTitle}) => {
  return (
    <Box className="bg-white p-24 text-lg pc:text-xl font-bold rounded-t-[12px] rounded-b-[4px] text-black-1">
      {sectionTitle}
    </Box>
  );
};
